export default "__VITE_ASSET__BeLHJlC1__"